import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Monitoring Activity: A specific compliance or oversight action related to subawards to ensure the subrecipient meets regulatory standards.',
    name: 'Subaward Monitoring Activities',
    partialId: PartialId.Standard.create('subaward_monitor_acts'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
